module.exports = __webpack_public_path__ + "static/media/birthdays-ai-logo-white.5a04759c.png";